export default __webpack_public_path__ + "static/media/14.edef6ef6.png";